import React from 'react';
import { reduxForm, Field } from 'redux-form';
import SelectField from '../../../SelectField';
import FormError from '../../../FormError';

let SuspendSimoDeviceForm = ({ handleSubmit, suspensionOptions, error }) => {
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Field
          component={SelectField}
          name="suspension_status"
          label="Suspension Reason"
          options={suspensionOptions}
          empty="Select suspension reason"
        />
        {error && <FormError error={error} />}
        <br />
        <button className="btn btn-primary">Suspend</button>
      </form>
    </div>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.suspension_status) {
    errors.suspension_status = 'Required';
  }

  return errors;
};

SuspendSimoDeviceForm = reduxForm({
  form: 'suspendDevice',
  validate,
})(SuspendSimoDeviceForm);

export default SuspendSimoDeviceForm;
